// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"8acfd9ce","353":"f0f18e66"}[chunkId] + ".js";
};